import Eventable from './eventable';

export class Model<
    T extends object = Record<string, unknown>,
> extends Eventable {
    attributes: T;

    constructor(attributes: Partial<T> = {}) {
        super();
        this.attributes = attributes as T;
    }

    get<K extends keyof T>(attr: K) {
        this.attributes = this.attributes || {};
        return this.attributes[attr];
    }

    set<K extends keyof T>(attr: K, val: T[K]) {
        this.attributes = this.attributes || {};

        if (this.attributes[attr] === val) {
            return;
        }
        const oldVal = this.attributes[attr];
        this.attributes[attr] = val;
        this.trigger(`change:${attr as string}`, this, val, oldVal);
    }
    clone() {
        return { ...this.attributes };
    }
}
